import { Injectable, } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import * as Stomp from 'stompjs';
import * as SockJS from 'sockjs-client';
import { environment } from '@environments/environment';
import { LatestPrices } from '@app/models/latest-prices';

@Injectable({
  providedIn: 'root'
})
export class SocketService {

  private subject$ = new BehaviorSubject<LatestPrices[]>([]);
  private isSocketConnected: boolean = false;
  private serverUrl: string;
  private stompClient: any;


  constructor() {
    this.serverUrl = `${environment.apiUrl}/socket`;      
    this.initializeSocketListeners();   
  }

  /**
   * Configure socket.
   */
  public initializeSocketListeners() {
    let ws = new SockJS(this.serverUrl);
    this.stompClient = Stomp.over(ws);
    // Attempt to reconnect every 5 secons.
    this.stompClient.reconnect_delay = 1000; //5000;
    let that = this;

    // Error handlers. There are many other methods also
    that.stompClient.onDisconnect = () => { that.reconnectWebSocket() }
    that.stompClient.onStompError = () => { that.reconnectWebSocket() }
    // This is the most important
    that.stompClient.onWebSocketClose = () => { that.reconnectWebSocket() }

    that.stompClient.connect({}, function (frame: any) {
      that.isSocketConnected = true;
      that.openGlobalSocket()
    }, () => {
      console.log("Websocket closed by server.");
      that.reconnectWebSocket();
    });
  }

  public reconnectWebSocket() {
    var that = this;
    const retryTimeout = 1; //5
    that.isSocketConnected = false;
    console.log('Re-connecting websocket after', retryTimeout * 1000, 'secs...')
    // Call the websocket connect method
    setTimeout(function () { that.initializeSocketListeners(); }, retryTimeout * 1000);
  }

  public openGlobalSocket(): void {
    this.stompClient.subscribe("/web-prices", (latestPricesMessage: any) => {
      let messageResult: string = latestPricesMessage.body;
      let prices: LatestPrices[] = JSON.parse(messageResult);
      // Update subject.
      this.updateMessage(prices);
    });
  }

  public getMessageSubject(): BehaviorSubject<LatestPrices[]> {
    return this.subject$;
  }

  private updateMessage(latestPrices: LatestPrices[]): void {
    this.subject$.next(latestPrices);
  }

}
